import { Component, OnInit } from '@angular/core';
import { PageSize } from '../../../core/dto/page.size';
import { Router } from '@angular/router';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Pagination } from '../../../core/dto/pagination';
import { CustomerService } from '../../../core/services/customer.service';
import * as _ from 'lodash';
import { SETTINGS } from '../../../core/config/common.settings';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-view-customer',
  templateUrl: './view-customer.component.html',
  styleUrls: ['./view-customer.component.scss'],
})
export class ViewCustomerComponent implements OnInit {
  breadcrumbs: any[] = [];
  searchText: any;
  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;
  customerData: any[] = [];

  skeletonTableColumns: any[] = [
    'Customer ID',
    'Customer Name',
    'Country',
    'Contact Number',
    'Created Date',
    'Actions',
  ];
  loading = false;

  constructor(
    private router: Router,
    private customerService: CustomerService,
    private message: NzMessageService,
  ) {}

  ngOnInit() {
    this.setBreadcrumbs();
    this.getPagedCustomers();
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedCustomers();
  }

  getPagedCustomers(): void {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        searchValue: this.searchText,
      },
    });
    this.customerService.getCustomerPaged(payload).subscribe(
      (res: any) => {
        this.loading = false;
        this.customerData = res.data;
        console.log(this.customerData);
        this.pageSize.length = res.totalItems;
      },
      (e: any) => {
        this.loading = false;
        this.message.create('error', 'Error');
      },
    );
  }

  search(): void {
    this.getPagedCustomers();
  }

  resetSearch(): void {
    this.searchText = null;
    this.getPagedCustomers();
  }

  setBreadcrumbs(): void {
    this.breadcrumbs = [
      {
        title: `Customers`,
        route: '/admin/customers',
      },
    ];
  }

  sort(): void {
    this.sortOrder = this.sortOrder === 1 ? -1 : 1;
    this.getPagedCustomers();
  }

  navigateNewCustomer(): void {
    this.router.navigate([`admin/customers/add-edit`]);
  }

  navigateToSingle(data: any): void {
    this.router.navigate([`admin/customers/${data}`]);
  }

  deleteCustomer(data: any): void {
    this.customerService.deleteCustomer(data).subscribe(
      () => {
        this.message.create(
          'success',
          'Customer has been deleted successfully!',
        );
        this.ngOnInit();
      },
      (e: any) => {
        this.message.create('error', 'Error');
      },
    );
  }

  editNavigate(data: any): void {
    this.router.navigate([`admin/customers/add-edit/${data}`]);
  }

  hasPermission(perm: string): boolean {
    return _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), perm);
  }
}
